import React from "react";
import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, Tooltip, PieChart, Pie, Cell } from "recharts";
import Card from "../ui/Card";
import Stat from "../ui/Stat";
import Table from "../ui/Table";

const growth = [
  { month: "Jan", sessions: 120 },
  { month: "Feb", sessions: 180 },
  { month: "Mar", sessions: 260 },
  { month: "Apr", sessions: 340 },
  { month: "May", sessions: 420 },
  { month: "Jun", sessions: 520 },
];

const segments = [
  { name: "Enterprise", value: 48 },
  { name: "Education", value: 24 },
  { name: "Healthcare", value: 16 },
  { name: "Sports", value: 12 },
];

const segmentColors = [
  "var(--ui-accent)",
  "var(--ui-accent-2)",
  "var(--ui-accent-3)",
  "var(--ui-accent-4)",
];

const pilots = [
  { account: "Acme Corp", seats: 120, status: "Active" },
  { account: "Nova Health", seats: 80, status: "Expansion" },
  { account: "Apex Athletics", seats: 45, status: "Pilot" },
];

export default function InvestorShowcase() {
  return (
    <div className="nia-page">
      <Card className="nia-hero">
        <div className="nia-header">
          <div>
            <h2>Investor Showcase</h2>
            <p>Product-market signal, enterprise readiness, and differentiated coaching intelligence.</p>
          </div>
          <div className="nia-pill">Confidential</div>
        </div>
      </Card>

      <div className="nia-grid nia-grid--4">
        <Stat label="Weekly Sessions" value="520" subtle="+21% MoM" />
        <Stat label="Active Orgs" value="14" subtle="Enterprise pilots" />
        <Stat label="Retention" value="92%" subtle="30-day" />
        <Stat label="Avg Response" value="6m" subtle="Coach follow-up" />
      </div>

      <div className="nia-grid nia-grid--2">
        <Card title="Engagement Growth">
          <div style={{ height: 240 }}>
            <ResponsiveContainer width="100%" height="100%" minWidth={10} minHeight={10} debounce={120}>
              <AreaChart data={growth}>
                <XAxis dataKey="month" stroke="var(--ui-muted)" tick={{ fill: "var(--ui-muted)", fontSize: 12 }} />
                <YAxis stroke="var(--ui-muted)" tick={{ fill: "var(--ui-muted)", fontSize: 12 }} />
                <Tooltip
                  contentStyle={{
                    background: "var(--ui-surface)",
                    border: "1px solid var(--ui-border)",
                    color: "var(--ui-text)",
                  }}
                />
                <Area type="monotone" dataKey="sessions" stroke="var(--ui-accent)" fill="var(--ui-accent)" fillOpacity={0.22} />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </Card>

        <Card title="Market Segments">
          <div style={{ height: 240 }}>
            <ResponsiveContainer width="100%" height="100%" minWidth={10} minHeight={10} debounce={120}>
              <PieChart>
                <Pie data={segments} dataKey="value" nameKey="name" outerRadius={90} innerRadius={45} paddingAngle={3}>
                  {segments.map((segment, index) => (
                    <Cell key={segment.name} fill={segmentColors[index % segmentColors.length]} />
                  ))}
                </Pie>
                <Tooltip
                  contentStyle={{
                    background: "var(--ui-surface)",
                    border: "1px solid var(--ui-border)",
                    color: "var(--ui-text)",
                  }}
                />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </Card>
      </div>

      <Card title="Investor Teaser">
        <div className="nia-video">
          <iframe
            src="https://www.youtube.com/embed/rEpkx1mMhpo"
            title="Nia COACH Investor Teaser"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </Card>

      <Card title="Pilot Accounts">
        <Table
          headers={["Account", "Seats", "Status"]}
          rows={pilots.map((pilot) => [pilot.account, pilot.seats, pilot.status])}
        />
      </Card>
    </div>
  );
}
